import AddTaskOutlinedIcon
    from "@mui/icons-material/AddTaskOutlined";

import {
    IconButton,
    Link,
    Tooltip
} from "@mui/material";

import React, {
    useState
} from "react";

import {
    CONFIGURATION_CATEGORY_URL,
    CONFIGURATION_ENVIRONMENT_URL,
    CONFIGURATION_RELATIONSHIP_URL,
    MAINTENANCE_WINDOW_URL,
    AFFECTED_SERVICES_URL,
    CHANGE_TYPE_URL
} from "../../Constants/Constants";

import AxiosInstance
    from "../../services/AxiosInstance";

import ConfigurationMasterForm
    from "./ConfigurationMasterForm";


function ConfigurationMasterDialog({

    configurationId = "",

    configurationName,

    variant = "button",

    type,

    onSuccess

}) {

    const [open, setOpen] =
        useState(false);

    const [editData, setEditData] =
        useState(null);

    const [loading, setLoading] =
        useState(false);


    const config = {

        category: {
            title: "Configuration Category",
            url: CONFIGURATION_CATEGORY_URL
        },

        environment: {
            title: "Configuration Environment",
            url: CONFIGURATION_ENVIRONMENT_URL
        },

        relationship: {
            title: "Configuration Relationship",
            url: CONFIGURATION_RELATIONSHIP_URL
        },

        maintenancewindow:
        {
            title: "Maintenance Window",
            url: MAINTENANCE_WINDOW_URL
        },
        affectedservice:
        {
            title: "Affected Service",
            url: AFFECTED_SERVICES_URL
        },
        changetype:
        {
            title: "Change Type",
            url: CHANGE_TYPE_URL
        }

    }[type];


    const handleClickOpen = async () => {

        if (
            configurationId &&
            configurationId !== ""
        ) {

            setLoading(true);

            try {

                const response =
                    await AxiosInstance.get(
                        `${config.url}/${configurationId}`
                    );

                setEditData(
                    response.data
                );

                setOpen(true);

            } catch (error) {

                console.error(
                    `Error fetching ${config.title} data:`,
                    error
                );

            } finally {

                setLoading(false);
            }

        } else {

            setEditData(null);

            setOpen(true);
        }
    };


    const handleClose = () => {

        setOpen(false);

        setEditData(null);
    };


    const renderTrigger = () => {

        if (
            variant === "link" &&
            configurationId
        ) {

            return (

                <Link
                    component="button"

                    onClick={
                        handleClickOpen
                    }

                    disabled={loading}

                    sx={{
                        cursor: "pointer",
                        textDecoration: "none",
                        color: "primary.main",

                        "&:hover": {
                            textDecoration:
                                "underline"
                        }
                    }}
                >

                    {configurationName}

                </Link>
            );
        }


        return (

            <Tooltip
                title={`Add ${config?.title || "Configuration"}`}
                onClick={handleClickOpen}
                disabled={loading}
            >

                <IconButton
                    sx={{
                        cursor: "pointer",
                        margin: "2px",
                        color: theme =>
                            theme.palette.grey[500],
                        border: 1,
                        borderColor: "divider",
                        borderRadius: 2
                    }}
                >

                    <AddTaskOutlinedIcon
                        color="primary"
                    />

                </IconButton>

            </Tooltip>
        );
    };


    return (

        <>

            {renderTrigger()}

            <ConfigurationMasterForm
                open={open}

                onClose={
                    handleClose
                }

                editData={
                    editData
                }

                type={type}

                onSaved={() => {
                    handleClose();

                    onSuccess?.();

                    window.dispatchEvent(
                        new CustomEvent("configuration-master-saved", {
                            detail: {
                                type: type
                            }
                        })
                    );
                }}

            />

        </>
    );
}


export default ConfigurationMasterDialog;